declare namespace $ {

	export class $mol_icon_face extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=face.view.tree.d.ts.map